import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
export default {
  data: function data() {
    return {};
  },
  props: {
    text: {
      type: String,
      default: '暂时数据'
    },
    size: {
      type: Number,
      default: 100
    },
    icon: {
      type: String,
      default: 'ios-cube-outline'
    },
    fontSize: {
      type: String,
      defalut: '22px'
    }
  }
};